var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bach-update" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "虚拟卡券客户批量改价",
            visible: _vm.dialogFormVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "form-box",
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "供应商：", prop: "supplierId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierId", $$v)
                        },
                        expression: "form.supplierId",
                      },
                    },
                    _vm._l(_vm.suppliers, function (opt) {
                      return _c("el-option", {
                        key: opt.id,
                        attrs: { label: opt.supplierName, value: opt.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { "label-width": "50px" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "goods",
                      model: {
                        value: _vm.form.isExcel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isExcel", $$v)
                        },
                        expression: "form.isExcel",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _c("div", { staticClass: "my-radio" }, [
                          _c("span", { staticClass: "font-w" }, [
                            _vm._v("表格导入商品："),
                          ]),
                          _vm._v(" "),
                          _vm.form.isExcel === 1
                            ? _c(
                                "div",
                                { staticClass: "upload-excel" },
                                [
                                  _c("UploadExcel", {
                                    attrs: { onSuccess: _vm.onSuccess },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(" 支持扩展名：.xlsx .csv")]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { staticClass: "sel-goods", attrs: { label: 2 } },
                        [
                          _c("div", { staticClass: "goods-list my-radio" }, [
                            _c(
                              "span",
                              {
                                staticClass: "font-w",
                                staticStyle: { "margin-top": "10px" },
                              },
                              [_vm._v("商品选择：")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "sel-table" }, [
                              _c(
                                "div",
                                { staticClass: "filter" },
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { inline: true } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品分类：" } },
                                        [
                                          _c("el-cascader", {
                                            staticClass: "selWidth mr20",
                                            attrs: {
                                              options: _vm.merCateList,
                                              props: _vm.props,
                                              clearable: "",
                                              size: "small",
                                            },
                                            model: {
                                              value: _vm.form.cateId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "cateId",
                                                  $$v
                                                )
                                              },
                                              expression: "form.cateId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品编号：" } },
                                        [
                                          _c("el-input", {
                                            attrs: { placeholder: "请输入" },
                                            model: {
                                              value: _vm.form.name,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "name", $$v)
                                              },
                                              expression: "form.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.search },
                                    },
                                    [_vm._v("填充商品")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-table",
                                    {
                                      key: _vm.form.isExcel,
                                      staticStyle: { width: "100%" },
                                      attrs: { data: _vm.tableData.list },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "55",
                                          selectable: function () {
                                            return _vm.form.isExcel === 2
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "productCode",
                                          label: "商品编码",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "productName",
                                          label: "商品名称",
                                          width: "200",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: { prop: "type", label: "分类" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "faceValue",
                                          label: "面值",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "priceType",
                                          label: "价格形式",
                                          width: "200",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.form.isExcel === 1,
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.priceType,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "priceType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.priceType",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.priceEnum,
                                                    function (rad) {
                                                      return _c(
                                                        "el-radio",
                                                        {
                                                          key: rad.value,
                                                          attrs: {
                                                            label: rad.value,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(rad.label)
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: { prop: "value", label: "值" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled:
                                                      _vm.form.isExcel === 1,
                                                  },
                                                  model: {
                                                    value: scope.row.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.value",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "更新时间：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { input: _vm.updateTimeFn },
                      model: {
                        value: _vm.form.updateTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "updateTime", $$v)
                        },
                        expression: "form.updateTime",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _c("span", [_vm._v("即时生效")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { attrs: { label: 2 } },
                        [
                          _c("span", [_vm._v("定时修改")]),
                          _vm._v(" "),
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "选择日期时间",
                              disabled: _vm.form.updateTime === 1,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.form.executionTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "executionTime", $$v)
                              },
                              expression: "form.executionTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "修改商户：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", multiple: "" },
                      model: {
                        value: _vm.form.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "customerId", $$v)
                        },
                        expression: "form.customerId",
                      },
                    },
                    _vm._l(_vm.merchantEnum, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定修改")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }